import api from '@/api/joywok'

const state = {

}

const actions = {
  getJoywokConfigParams ({ commit }, { params }) {
    return api.getJoywokConfigParams(params)
  },
  getEmployeeInfo ({ commit }, { code, params }) {
    return api.getEmployeeInfo(code, params)
  },
  checkAutoLogin ({ commit }, { params }) {
    return api.checkAutoLogin(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
